import { LanguageOption } from "../types/LanguageOption"

export const FormQueryKeys = {
  all: ["forms"] as const,
  byProvince: (province: string) => [FormQueryKeys.all, province] as const,
  byProvinceAndLanguage: (province: string, language?: LanguageOption) =>
    [FormQueryKeys.all, FormQueryKeys.byProvince(province), language] as const,
  byId: (id: string) => [FormQueryKeys.all, id] as const,
  byIdAndLanguage: (id: string, language?: LanguageOption) =>
    [FormQueryKeys.all, id, language] as const,
  byIdLanguageAndVersion: (
    id: string,
    language?: LanguageOption,
    v2?: boolean,
  ) => ["forms", id, language, v2] as const,
}
